import { V9ReportParameter } from './v9-report-parameter.model';

export class V9ParameterRow {
    Parameters: V9ReportParameter[] = [];
    IncludeLineAtStartOfGroup: boolean;
    IncludeLineAtEndOfGroup: boolean;
}

export class V9ParameterRows {
    Rows: V9ParameterRow[] = [];
}
